<template>
    <div class="user-center">
        <Loading v-if="!loading"/>
        <div class="user-center-top" v-if="loading">
            <div class="user-avatar">
                <img :src="userInfo&&userInfo.icon" alt="">
            </div>
            <div class="user-name"><div class="user-name-text">{{userInfo&&userInfo.real_name?userInfo.real_name:'待完善'}}<span class="authen-tag" v-if="userInfo&&userInfo.real_name_auth==1">已认证</span></div></div>
            <p class="authen-date" v-if="userInfo.is_vip&&userInfo.is_vip.value">兑换码有效期至{{userInfo.is_vip.date?userInfo.is_vip.date.substring(0,10):''}} </p>
            <div class="top-bottom">
                <div class="my-script-follow-box">
                    <router-link :to="{name:'myscriptlist'}">
                        <div class="my-script">
                            <p class="num">{{userInfo&&userInfo.my_article_count}}</p>
                            <p class="text">我的剧本</p>
                        </div>
                    </router-link>
                    <router-link :to="{name:'followlist'}">
                        <div class="my-follow">
                            <p class="num">{{userInfo&&userInfo.my_follow_count}}</p>
                            <p class="text">我的关注</p>
                        </div>
                    </router-link>
                </div>
                <router-link :to="{name:'edituserinfo'}"><div class="authen-btn"><span>编辑资料</span>></div></router-link>
            </div>
        </div>
        <ul class="user-info-item">
            <li><span class="item-key">笔名</span><span class="item-value">{{userInfo&&userInfo.name?userInfo.name:'待完善'}}</span></li>
            <li><span class="item-key">真实姓名</span><span class="item-value">{{userInfo&&userInfo.real_name?userInfo.real_name:'待完善'}}</span></li>
            <li><span class="item-key">性别</span><span class="item-value">{{userInfo&&userInfo.sex.name?userInfo.sex.name:'待完善'}}</span></li>
            <li><span class="item-key">出生日期</span><span class="item-value">{{userInfo&&userInfo.birthday?userInfo.birthday:'待完善'}}</span></li>
            <li><span class="item-key">手机号</span><span class="item-value">{{userInfo&&userInfo.phone?userInfo.phone:'待完善'}}</span></li>
            <li><span class="item-key">最高学历</span><span class="item-value">{{userInfo&&userInfo.education?userInfo.education:'待完善'}}</span></li>
            <li><span class="item-key">所在地区</span><span class="item-value">{{userInfo.province&&userInfo.province.name?userInfo.province.name+userInfo.city.name+userInfo.district.name:'待完善'}}</span></li>
            <li><span class="item-key">邮箱</span><span class="item-value">{{userInfo&&userInfo.email?userInfo.email:'待完善'}}</span></li>
            <li><span class="item-key">自我介绍</span><span class="item-value value-break-line">{{userInfo&&userInfo.intro?userInfo.intro:'待完善'}}</span></li>
            <li><span class="item-key">代表作品</span><span class="item-value value-break-line">{{userInfo&&userInfo.works?userInfo.works:'待完善'}}</span></li>
            <li><span class="item-key">擅长题材</span><span class="item-value value-break-line">{{userInfo&&userInfo.adept?userInfo.adept:'待完善'}}</span></li>
            <li><span class="item-key">作品及获奖介绍</span><span class="item-value value-break-line">{{userInfo&&userInfo.prize?userInfo.prize:'待完善'}}</span></li>
        </ul>
    </div>    
</template>

<script>
import {Axios} from '@/assets/api/axios'
import Loading from '@/components/Loading'
export default {
    name:'UserCenter',
    data(){
        return{
            userInfo:'',
            loading:false
        }
    },
    created(){
        Axios.get('/user/info').then(
            response=>{
                if(response.data.code==200&&response.data.status=="success"){
                    this.userInfo=response.data.data
					this.loading=true
                }
            }
        ).catch(
            error=>{
                console.log(error)
            }
        )
    },
    components:{
        Loading
    }
}
</script>

<style lang="scss" scoped>
    .user-center{
        padding-top:88px;
        .user-center-top{
            padding:30px 44px;
            background:#f8f6f7;
            .user-avatar{
                width:140px;
                height:140px;
                margin:0 auto;
                margin-bottom:30px;
                img{
                    width:100%;
					height:100%;
                }
            }
            .user-name{
                font-size:32px;
                height:34px;
                color:#222;
                font-weight:bold;
                margin-bottom:16px;
                text-align:center;
                position:relative;
                .authen-tag{
                    position:absolute;
                    top:0;
                    margin-left:10px;
                    display:inline-block;
                    width:76px;
                    padding:5px 0;
                    border:1px solid #bf0000;
                    border-radius:35px;
                    text-align:center;
                    font-size:20px;
                    color:#bf0000;
                }
            }
            .authen-date{
                font-size:24px;
                height:24px;
                color:#999;
                text-align:center;
                margin-bottom:30px;
            }
            .top-bottom{
                height:74px;
                .my-script-follow-box{
                    width:476px;
                    height:74px;
                    margin-right:10px;
                    display:inline-block;
                    background:#fff;
                    .my-script,.my-follow{
                        display:inline-block;
                        text-align:center;
                        width:238px;
                        padding:13px 0;
                        position:relative;
                        .num{
                            font-size:24px;
                            color:#222;
                            font-weight:bold;
                            height:26px;
                            margin-bottom:4px;
                        }
                        .text{
                            font-size:20px;
                            color:#222;
                        }
                    }
                    .my-script::before{
                        content:'';
                        width:2px;
                        height:20px;
                        background:#ccc;
                        position:absolute;
                        right:-1px;
                        top:50%;
                        margin-top:-10px;
                    }
                }
                .authen-btn{
                    display:inline-block;
                    height:74px;
                    line-height:74px;
                    width:176px;
                    text-align:center;
                    background:#bf0000;
                    color:#fff;
                    vertical-align:top;
                    font-size:24px;
                    span{
                        margin-right:10px;
                    }
                }
                .authen-btn:active{
                    background:#DD8080;
                }
            }
        }
        .user-info-item{
            padding-bottom:20px;
            li{
                padding:36px 44px;
                color:#222;
                overflow:hidden;
                .item-key{
                    font-size:26px;
                    float:left;
                    font-weight:bold;
					transform:translateY(-4px);
                }
                .item-value{
                    font-size:26px;
                    float:right;
                }
                .value-break-line{
                    width:460px;
                    word-break:break-all;
                    line-height:30px;
                }
            }
        }
    }
</style>